/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Faq_Agents_DetailInputs */

const en_marketing_faq_agents_detail = /** @type {(inputs: Marketing_Faq_Agents_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, deliberately. Focused packages, per-package READMEs, a maintained CLAUDE.md, and typed contracts give agents the structure they need to make correct changes.`)
};

const es_marketing_faq_agents_detail = /** @type {(inputs: Marketing_Faq_Agents_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, deliberadamente. Los paquetes enfocados, los README por paquete, un CLAUDE.md mantenido y los contratos tipados dan a los agentes la estructura que necesitan para hacer cambios correctos.`)
};

const fr_marketing_faq_agents_detail = /** @type {(inputs: Marketing_Faq_Agents_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui, délibérément. Des paquets ciblés, un README par paquet, un CLAUDE.md maintenu et des contrats typés donnent aux agents la structure nécessaire pour faire les bons changements.`)
};

/**
* | output |
* | --- |
* | "Yes, deliberately. Focused packages, per-package READMEs, a maintained CLAUDE.md, and typed contracts give agents the structure they need to make correct cha..." |
*
* @param {Marketing_Faq_Agents_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_faq_agents_detail = /** @type {((inputs?: Marketing_Faq_Agents_DetailInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Faq_Agents_DetailInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_faq_agents_detail(inputs)
	if (locale === "es") return es_marketing_faq_agents_detail(inputs)
	return fr_marketing_faq_agents_detail(inputs)
});